// extracted by mini-css-extract-plugin
export default {"heading":"LandscapeAboutCommittedBuyersAddPartnerTemplate_heading__meUI9","buttonLink":"LandscapeAboutCommittedBuyersAddPartnerTemplate_buttonLink__0Q3kI"};